import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";

import tokenUtils from "../utils/tokenUtils";
import { REACT_APP_CALL_SERVICE_URL } from "../constants/constants";

export const connectCall = async (payload) => {
  const token = tokenUtils.getToken();
  const endpoint = `${REACT_APP_CALL_SERVICE_URL}/connect-call`;
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: payload,
  };

  return await fetchJSON(endpoint, options);
};

export const useConnectCall = () => {
  return useMutation({
    mutationFn: connectCall,
  });
};
